var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_546_5817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6252 8.50001V15.2083C14.6252 16.4975 13.581 17.5417 12.2918 17.5417C11.0027 17.5417 9.9585 16.4975 9.9585 15.2083V7.91668C9.9585 7.11168 10.6118 6.45834 11.4168 6.45834C12.2218 6.45834 12.8752 7.11168 12.8752 7.91668V14.0417C12.8752 14.3625 12.6156 14.625 12.2918 14.625C11.9681 14.625 11.7085 14.3625 11.7085 14.0417V8.50001H10.8335V14.0417C10.8335 14.8467 11.4868 15.5 12.2918 15.5C13.0968 15.5 13.7502 14.8467 13.7502 14.0417V7.91668C13.7502 6.62751 12.706 5.58334 11.4168 5.58334C10.1277 5.58334 9.0835 6.62751 9.0835 7.91668V15.2083C9.0835 16.9817 10.5214 18.4167 12.2918 18.4167C14.0622 18.4167 15.5002 16.9817 15.5002 15.2083V8.50001H14.6252Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_546_5817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.97d9356ef8127d44cbb746f80583f25b.svg";
export { ForwardRef as ReactComponent };